import { l as _inherits, a as _createClass, b as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

var Title = /*#__PURE__*/function (_Component) {
  function Title(props) {
    var _this;
    _classCallCheck(this, Title);
    _this = _callSuper(this, Title, [props]);
    var renderAs = _this.props.renderAs;
    var allowedRenderTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    var tagName = allowedRenderTags.some(function (validTag) {
      return validTag === renderAs;
    }) ? renderAs : 'div';
    // eslint-disable-next-line react/no-unused-state
    _this.state = {
      tagName: tagName
    };
    return _this;
  }
  _inherits(Title, _Component);
  return _createClass(Title, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        content = _this$props.content,
        onClick = _this$props.onClick;
      var size = this.props.size;
      var allowedSizes = ['small', 'normal', 'medium', 'large', 'xlarge', 'huge', 'extra'];
      size = allowedSizes.some(function (validSize) {
        return validSize === size;
      }) ? "bf-title-".concat(size) : '';
      return /*#__PURE__*/React__default.createElement(this.state.tagName, {
        className: "bf-title ".concat(size, " ").concat(className),
        onClick: onClick
      }, content || children);
    }
  }]);
}(Component);
Title.defaultProps = {
  className: '',
  children: '',
  content: '',
  renderAs: '',
  size: 'normal',
  onClick: function onClick() {}
};
Title.propTypes = {
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Title content
   */
  children: nodeOrStringProp,
  /**
  Title content
   */
  content: nodeOrStringProp,
  /**
  Render as h1/h6 tag
   */
  renderAs: PropTypes.string,
  /**
  Title size
   */
  size: PropTypes.string,
  /**
  onClick handler
   */
  onClick: PropTypes.func
};

export default Title;
